import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { useEffect, useState } from "react";
import {
  NFCeModalDestinatarioSchema,
  NFCeModalPagamentoSchema,
} from "./NFCe.Modal.Finalizar.Dto";
import { FormatarVirgulaPonto, SoNumeros } from "src/hook/Functions";
import {
  DestinatarioNFCeDto,
  MeioPagamentoDto,
  MeioPagamentoNFCeDto,
} from "../NFCe.Dto";

const NFCeModalFinalizaCode = (
  dataMeioPagamento: MeioPagamentoNFCeDto[],
  onSelect: (value: MeioPagamentoNFCeDto) => void,
  onHide: () => void,
  onCancel: () => void,
  totalNFCe: number,
  onSubmit: (value: DestinatarioNFCeDto | undefined) => void
) => {
  const totalPago = () => {
    const pago = dataMeioPagamento.reduce(
      (acc, item) => acc + Number(item.valorPagamento),
      0
    );
    return pago;
  };

  const totalTroco = () => {
    const troco = totalPago() - totalNFCe;
    if (troco < 0) {
      return 0;
    }
    return troco;
  };

  const podeFinalizar = () => {
    return totalPago() >= totalNFCe;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setFocus,
    reset,
  } = useForm<MeioPagamentoNFCeDto>({
    resolver: yupResolver(NFCeModalPagamentoSchema),
  });

  const {
    register: registerDestinatario,
    handleSubmit: handleSubmitDestinatario,
    formState: { errors: errorsDestinatario },
    setFocus: setFocusDestinatario,
    reset: resetDestinatario,
  } = useForm<DestinatarioNFCeDto>({
    resolver: yupResolver(NFCeModalDestinatarioSchema),
  });

  const [exibirValor, setExibirValor] = useState(false);
  const [selecionadoMeioPagamento, setSelecionadoMeioPagamento] =
    useState<MeioPagamentoDto>();

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setFocus("valorPagamento");
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [exibirValor]);

  const onSubmitMeioPagamento = async (data: MeioPagamentoNFCeDto) => {
    data.meioPagamento = selecionadoMeioPagamento?.meioPagamento;
    data.valorPagamento = FormatarVirgulaPonto(data.valorPagamento);
    onSelect(data);
    setExibirValor(false);
    setSelecionadoMeioPagamento(undefined);
    reset();
  };

  const onSubmitDestinatario = async (
    data: DestinatarioNFCeDto | undefined
  ) => {
    onHide();
    if (data && data.documento) {
      data.documento = SoNumeros(data.documento);
      data.indicadorInscricaoEstadual = 9;
    } else {
      data = undefined;
    }
    onSubmit(data);
  };

  const handleClickMeioPagamento = (value: MeioPagamentoDto) => () => {
    setSelecionadoMeioPagamento(value);
    setExibirValor(true);
  };

  const onHideClick = () => {
    if (exibirValor) {
      reset();
      setExibirValor(false);
    } else {
      onHide();
    }
  };

  const onCancelClick = () => {
    setExibirValor(false);
    onCancel();
  };

  return {
    register,
    handleSubmit,
    onSubmitMeioPagamento,
    errors,
    exibirValor,
    setExibirValor,
    selecionadoMeioPagamento,
    setSelecionadoMeioPagamento,
    handleClickMeioPagamento,
    totalPago,
    totalTroco,
    onHideClick,
    podeFinalizar,
    onCancelClick,
    onSubmitDestinatario,
    handleSubmitDestinatario,
    registerDestinatario,
    errorsDestinatario,
  };
};

export default NFCeModalFinalizaCode;
